import { NotificationContentBase, ScheduleReportFinishedCompleteNotification } from '../../services/api.services';
import { BasicNotification } from '../models/basic-notification';

export function schedulerReportMapping(content: NotificationContentBase, time: string) {
    let schedulereportFinished = <ScheduleReportFinishedCompleteNotification>content;
    return <BasicNotification>{
        id: schedulereportFinished.id,
        iconUrl: schedulereportFinished.succesful ? "/assets/img/notification-icons/schedule-success.svg" : "/assets/img/notification-icons/schedule-warning.svg",
        pendingUrl: "/assets/img/notification-icons/schedule-grey.svg",
        color: schedulereportFinished.succesful ? "#6DD400" : "#F29100",
        headline: "Scheduled Report",
        title: schedulereportFinished.scheduleName,
        message: schedulereportFinished.succesful ? "has completed successfully" : "has failed to complete",
        buttons: [
            {
                label: "Edit",
                url: `scheduler/${schedulereportFinished.id}`
            }
        ],
        time: time
    };
}
